module.exports = __webpack_public_path__ + "img/probuild.a5ed89b0.png";